import React from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/ClearOutlined";


const TextFieldCommon = ({ search, searchChange, handleClear, placeholder }) => {
  const styleField = {
    width: '100%',
  };

  return (
    <>
  	<TextField
          style={styleField}
          variant="standard"
          placeholder={placeholder}
          value={search}
          onChange={searchChange}
          InputProps={{
            endAdornment: (
              <IconButton onClick={handleClear} edge="end">
                <ClearIcon />
              </IconButton>
            )
          }}
        />
      </>
  );
};

TextFieldCommon.defaultProps = {
    placeholder: "Search Text"
};

export default TextFieldCommon;
